import { FormControl } from 'baseui/form-control'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import formatUTCDate from '@/shared/tools/formatUTCDate'
import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { getAuthorizationText } from '@/shared/utils/meterAuthorizationUtils'

const MeterConsent = () => {
  const {
    t,
    canRequestMeterData,
    isValidPce,
    meterConsent,
    consentDate,
    prestationType,
    requestPceEligibility,
    gasMeterUpdate,
  } = useGasMeter({ type: 'client' })

  if (!canRequestMeterData) {
    return null
  }

  const primaryTextForAuthorization = getAuthorizationText(t, prestationType, 'gas')
  const primaryTextForAutorized = `${t('subscriptionForm:pce_module.meter_authorization.authorized')} ${new Date(consentDate).toLocaleString('fr-FR')}`

  // todo-v2: review if we can convert it to a normal button
  return (
    <>
      <SDNotification type='info' hidden={meterConsent} primaryText={primaryTextForAuthorization}>
        <FormControl
          overrides={{
            ControlContainer: {
              style: () => ({
                marginBottom: 0,
                marginTop: '.5rem',
              }),
            },
          }}
        >
          <SDButtonGroup
            disabledOptions={(() => {
              if (meterConsent === true || !isValidPce) {
                return ['true', 'false']
              }
              if (
                canRequestMeterData ||
                isValidPce
                // && isEditable === true TODO: isEditable undefined, pending to implement
              ) {
                return []
              }
              return ['true', 'false']
            })()}
            onClickHandler={value => {
              gasMeterUpdate({
                meterConsent: value === 'true',
                consentDate: formatUTCDate(new Date()),
              })

              requestPceEligibility()
            }}
            options={[{ true: t('subscriptionForm:pce_module.meter_authorization.authorize_yes') }]}
            selectedValue={meterConsent ? meterConsent?.toString() : 'false'}
          />
        </FormControl>
      </SDNotification>

      <SDNotification type='info' hidden={!meterConsent} primaryText={primaryTextForAutorized} />
    </>
  )
}

export default MeterConsent
